<template>
    <div>
        <multiselect
            :select-label="customSelectLabel"
            :deselect-label="customDeselectLabel"
            :placeholder="customPlaceholder"
            :options="languages"
            v-model="value"
            :multiple="true"
            :close-on-select="true"
            :clear-on-select="false"
            :max="30"
            label="name"
            track-by="name"
            :searchable="true"
            :preselect-first="true"
            :selectedLabel="customSelectedLabel"
            :limit="30"
            @input="addValueToInput"
        >
            <template slot="maxElements">{{ customMaxElementsText }}</template>
        </multiselect>
    </div>
</template>

<script>
import { translate } from '../../../helper/translate';
import Multiselect from 'vue-multiselect';
import { testIsNonEmptyString } from '../../../../lib/test-and-assert/test-base';
import { projectHelper } from '../../../../lib-sat/misc/project-helper';

export default {
    name: 'ocrmultiselect',
    components: { Multiselect },
    mounted: function () {
        this.init();
    },
    data() {
        return {
            options: [
                { name: translate('English'), language: 'eng' },
                { name: translate('Russian'), language: 'rus' },
                { name: translate('German'), language: 'deu' },
                { name: translate('Spanish'), language: 'spa' },
                { name: translate('French'), language: 'fra' },
                { name: translate('Indonesian'), language: 'ind' },
                { name: translate('Portuguese'), language: 'por' },
                { name: translate('Arabic'), language: 'ara' },
                { name: translate('Hindi'), language: 'hin' },
                { name: translate('Italian'), language: 'ita' },
                { name: translate('Chinese (simplified)'), language: 'chi_sim' },
                { name: translate('Vietnamese'), language: 'vie' },
                { name: translate('Afrikaans'), language: 'afr' },
                { name: translate('Albanian'), language: 'sqi' },
                { name: translate('Amharic'), language: 'amh' },
                { name: translate('Armenian'), language: 'hye' },
                { name: translate('Assamese'), language: 'asm' },
                { name: translate('Azerbaijani'), language: 'aze' },
                { name: translate('Azerbaijani (Cyrillic)'), language: 'aze_cyrl' },
                { name: translate('Basque'), language: 'eus' },
                { name: translate('Belorussian'), language: 'bel' },
                { name: translate('Bengali'), language: 'ben' },
                { name: translate('Bosnian'), language: 'bos' },
                { name: translate('Breton'), language: 'bre' },
                { name: translate('Bulgarian'), language: 'bul' },
                { name: translate('Burmese'), language: 'mya' },
                { name: translate('Canadian - Aboriginal'), language: 'script-Canadian_Aboriginal' },
                { name: translate('Castilian, Spanish - Old'), language: 'spa_old' },
                { name: translate('Catalan'), language: 'cat' },
                { name: translate('Cebuano'), language: 'ceb' },
                { name: translate('Cherokee'), language: 'chr' },
                { name: translate('Chinese - Simplified (Vertical)'), language: 'chi_sim_vert' },
                { name: translate('Chinese (traditional)'), language: 'chi_tra' },
                { name: translate('Chinese - Traditional (Vertical)'), language: 'chi_tra_vert' },
                { name: translate('Corsican'), language: 'cos' },
                { name: translate('Croatian'), language: 'hrv' },
                { name: translate('Czech'), language: 'ces' },
                { name: translate('Danish'), language: 'dan' },
                { name: translate('Devanagari'), language: 'script-Devanagari' },
                { name: translate('Divehi'), language: 'div' },
                { name: translate('Dutch'), language: 'nld' },
                { name: translate('Dzongkha'), language: 'dzo' },
                { name: translate('English (ancient)'), language: 'enm' },
                { name: translate('Esperanto'), language: 'epo' },
                { name: translate('Estonian'), language: 'est' },
                { name: translate('Ethiopic'), language: 'script-Ethiopic' },
                { name: translate('Faroese'), language: 'fao' },
                { name: translate('Filipino'), language: 'fil' },
                { name: translate('Finnish'), language: 'fin' },
                { name: translate('Frankish'), language: 'frk' },
                { name: translate('Fraktur'), language: 'script-Fraktur' },
                { name: translate('French (ancient)'), language: 'frm' },
                { name: translate('Frisian (Western)'), language: 'fry' },
                { name: translate('Gaelic (Scots)'), language: 'gla' },
                { name: translate('Galician'), language: 'glg' },
                { name: translate('Georgian'), language: 'kat' },
                { name: translate('Georgian - Old'), language: 'kat_old' },
                { name: translate('Greek'), language: 'ell' },
                { name: translate('Greek (ancient)'), language: 'grc' },
                { name: translate('Gujarati'), language: 'guj' },
                { name: translate('Gurmukhi'), language: 'script-Gurmukhi' },
                { name: translate('Haitian'), language: 'hat' },
                { name: translate('Hangul'), language: 'script-Hangul' },
                { name: translate('Hangul (Vertical)'), language: 'script-Hangul_vert' },
                { name: translate('HanS'), language: 'script-HanS' },
                { name: translate('HanS (Vertical)'), language: 'script-HanS_vert' },
                { name: translate('HanT'), language: 'script-HanT' },
                { name: translate('HanT (Vertical)'), language: 'script-HanT_vert' },
                { name: translate('Hebrew'), language: 'heb' },
                { name: translate('Hungarian'), language: 'hun' },
                { name: translate('Icelandic'), language: 'isl' },
                { name: translate('Inuktitut'), language: 'iku' },
                { name: translate('Irish'), language: 'gle' },
                { name: translate('Italian - Old'), language: 'ita_old' },
                { name: translate('Japanese'), language: 'jpn' },
                { name: translate('Japanese (Vertical)'), language: 'jpn_vert' },
                { name: translate('Javanese'), language: 'jav' },
                { name: translate('Kannada'), language: 'kan' },
                { name: translate('Kazakh'), language: 'kaz' },
                { name: translate('Khmer'), language: 'khm' },
                { name: translate('Korean'), language: 'kor' },
                { name: translate('Korean (Vertical)'), language: 'kor_vert' },
                { name: translate('Kurmanji (Latin)'), language: 'kmr' },
                { name: translate('Kyrgyz'), language: 'kir' },
                { name: translate('Lao'), language: 'lao' },
                { name: translate('Latvian'), language: 'lav' },
                { name: translate('Latin'), language: 'lat' },
                { name: translate('Lithuanian'), language: 'lit' },
                { name: translate('Luxembourgish'), language: 'ltz' },
                { name: translate('Macedonian'), language: 'mkd' },
                { name: translate('Malay'), language: 'msa' },
                { name: translate('Malayalam'), language: 'mal' },
                { name: translate('Maltese'), language: 'mlt' },
                { name: translate('Maori'), language: 'mri' },
                { name: translate('Marathi'), language: 'mar' },
                { name: translate('Mongolian'), language: 'mon' },
                { name: translate('Myanmar'), language: 'script-Myanmar' },
                { name: translate('Nepali'), language: 'nep' },
                { name: translate('Norwegian'), language: 'nor' },
                { name: translate('Occitan (Post 1500)'), language: 'oci' },
                { name: translate('Oriya'), language: 'ori' },
                { name: translate('Pashto'), language: 'pus' },
                { name: translate('Persian'), language: 'fas' },
                { name: translate('Polish'), language: 'pol' },
                { name: translate('Punjabi'), language: 'pan' },
                { name: translate('Quechua'), language: 'que' },
                { name: translate('Romanian'), language: 'ron' },
                { name: translate('Sanskrit'), language: 'san' },
                { name: translate('Serbian'), language: 'srp' },
                { name: translate('Serbian (Latin)'), language: 'srp_latn' },
                { name: translate('Sindhi'), language: 'snd' },
                { name: translate('Sinhala'), language: 'sin' },
                { name: translate('Slovakian'), language: 'slk' },
                { name: translate('Slovenian'), language: 'slv' },
                { name: translate('Sundanese'), language: 'sun' },
                { name: translate('Swahili'), language: 'swa' },
                { name: translate('Swedish'), language: 'swe' },
                { name: translate('Syriac'), language: 'syr' },
                { name: translate('Tajik'), language: 'tgk' },
                { name: translate('Tamil'), language: 'tam' },
                { name: translate('Tatar'), language: 'tat' },
                { name: translate('Telugu'), language: 'tel' },
                { name: translate('Thaana'), language: 'script-Thaana' },
                { name: translate('Thai'), language: 'tha' },
                { name: translate('Tibetan Standard'), language: 'bod' },
                { name: translate('Tigrinya'), language: 'tir' },
                { name: translate('Tonga'), language: 'ton' },
                { name: translate('Turkish'), language: 'tur' },
                { name: translate('Ukrainian'), language: 'ukr' },
                { name: translate('Urdu'), language: 'urd' },
                { name: translate('Uyghur'), language: 'uig' },
                { name: translate('Uzbek'), language: 'uzb' },
                { name: translate('Uzbek (Cyrillic)'), language: 'uzb_cyrl' },
                { name: translate('Welsh'), language: 'cym' },
                { name: translate('Yiddish'), language: 'yid' },
                { name: translate('Yoruba'), language: 'yor' },
            ],
            optionsForExcel: [
                'cat',
                'dan',
                'deu',
                'eng',
                'spa',
                'fin',
                'fra',
                'ita',
                'nld',
                'nor',
                'pol',
                'por',
                'ron',
                'rus',
                'slv',
                'swe',
                'tur',
            ],
            value: [],
            selectionCount: 1,
            languages: [],
            selectedLanguagesLayout: [],
            selectedLanguagesText: [],
            OCRLocale: {
                en: { language: 'eng', name: 'English' },
                de: { language: 'deu', name: 'German' },
                deu: { language: 'deu', name: 'German' },
                fr: { language: 'fra', name: 'French' },
                fra: { language: 'fra', name: 'French' },
                es: { language: 'spa', name: 'Spanish' },
                spa: { language: 'spa', name: 'Spanish' },
                ru: { language: 'rus', name: 'Russian' },
                rus: { language: 'rus', name: 'Russian' },
                hi: { language: 'hin', name: 'Hindi' },
                hin: { language: 'hin', name: 'Hindi' },
                zh: { language: 'chi_sim', name: 'Chinese (simplified)' },
                pt: { language: 'por', name: 'Portuguese' },
                por: { language: 'por', name: 'Portuguese' },
                vi: { language: 'vie', name: 'Vietnamese' },
                vie: { language: 'vie', name: 'Vietnamese' },
                it: { language: 'ita', name: 'Italian' },
                ita: { language: 'ita', name: 'Italian' },
                ar: { language: 'ara', name: 'Arabic' },
                ara: { language: 'ara', name: 'Arabic' },
                id: { language: 'ind', name: 'Indonesian' },
                ind: { language: 'ind', name: 'Indonesian' },
            },
        };
    },
    methods: {
        init: function () {
            let initialTarget = this.getCurrentTargetFormat();
            this.languages = this.options;

            //OCR'ing excel does not support all available languages
            if (initialTarget === 'xlsx' || initialTarget === 'xls') {
                this.languages = this.getAvailableOptionsForExcel();
            } else {
              //user locale should not be set for "Image to text"-Feature in ocr2edit
                this.setDefaultToUserLocale();
            }

            //Preserve languages that were selected for each ocr mode
            $('#inputTarget').on('change', () => {
                if (this.isOcrModeLayoutSelected()) {
                    this.value = this.selectedLanguagesLayout;
                } else {
                    this.value = this.selectedLanguagesText;
                }

                this.updateLanguageInput();
            });

          //Preserve languages that were selected for each ocr mode
            $('#ocr_mode').on('change', () => {
                if (this.isOcrModeSelectable() && this.isOcrModeLayoutSelected()) {
                    this.value = this.selectedLanguagesLayout;
                }

                if (this.isOcrModeSelectable() && this.isOcrModeTextSelected()) {
                    this.value = this.selectedLanguagesText;

                    $('.ocr_monochrome_selection').addClass('hidden');
                }

                this.updateLanguageInput();
            });

            const data = qgFeaturePage.getOptionsFromForm('#sendform');
            qgFeaturePage.showRelevantOptionsForTarget(data.category, data.target, window.qgUploader);
        },
        isOcrModeSelectable() {
            const ocrModeElement = $('#ocr_mode');
            if (ocrModeElement.length > 0 && ocrModeElement.is(':visible')) {
                return true;
            }

            return false;
        },
        getCurrentOcrModeValue() {
            const ocrModeElement = $('#ocr_mode');
            if (ocrModeElement.length === 0 || ocrModeElement.is(':hidden')) {
                return null;
            }

            return ocrModeElement?.find('option:selected')?.val()?.toLocaleLowerCase()?.trim();
        },
        isOcrModeLayoutSelected() {
            return this.getCurrentOcrModeValue() === 'layout';
        },
        isOcrModeTextSelected() {
            return this.getCurrentOcrModeValue() === 'text';
        },
        getCurrentTargetFormat() {
            let target = $('input[name="target"]').val();
            const selectTarget = $('select[name="target"]').val();

            if (testIsNonEmptyString(selectTarget)) {
                return selectTarget;
            }

            return target;
        },
        addValueToInput: function () {
            if (this.isOcrModeSelectable()) {
                if (this.isOcrModeLayoutSelected()) {
                    this.selectedLanguagesLayout = this.value;
                }

                if (this.isOcrModeTextSelected()) {
                    this.selectedLanguagesText = this.value;
                }
            }

            if (this.value.length === 0) {
                this.value = [{ name: translate('English'), language: 'eng' }];
            }

            this.updateLanguageInput();
            this.selectionCount++;
        },
        setDefaultToUserLocale: function () {
            let userLanguage = $('#inputLanguage').data('user-language');
            $('#inputLanguage').attr('value', this.OCRLocale[userLanguage].language);

            let defaultLocale = this.getDefaultLocale(userLanguage);

            this.value.push(defaultLocale);
            this.selectedLanguagesText = this.value;
            this.selectedLanguagesLayout = this.value;
            this.updateLanguageInput();
        },
        //update value of hidden #inputLanguage element with the value of the ocr multiselect converted to String
        updateLanguageInput: function () {
            let ocrLanguages = [];

            this.value.forEach((entry) => {
                ocrLanguages.push(entry.language);
            });

            $('#inputLanguage').data('amount-languages', ocrLanguages.length);
            ocrLanguages = ocrLanguages.toString();
            $('#inputLanguage').attr('value', ocrLanguages);
        },
        getDefaultLocale: function (userLanguage) {
            let localeObject = this.OCRLocale['en'];

            if (this.OCRLocale.hasOwnProperty(userLanguage)) {
                localeObject = this.OCRLocale[userLanguage];
            }

            return { name: translate(localeObject.name), language: localeObject.language };
        },
        getAvailableOptionsForExcel() {
            return this.options.filter((entry) => this.optionsForExcel.includes(entry.language));
        },
        shouldSetDefaultToUserLocale() {
            const convertToTxtFeatureUrls = [
                '/convert-to-txt',
                '/id/konversi-ke-txt',
                '/fr/convertir-en-txt',
                '/de/in-txt-umwandeln',
                '/es/convertir-a-txt',
                '/pt/converter-para-txt',
                '/it/convertire-in-txt',
                '/ar/convert-to-txt',
                '/hi/convert-to-txt',
                '/zh/convert-to-txt',
                '/ru/convert-to-txt',
                '/vi/convert-to-txt',
            ];

            if (!projectHelper.isOcr2edit()) {
                return true;
            }

            if (this.getCurrentTargetFormat() !== 'txt') {
                return true;
            }

            return !convertToTxtFeatureUrls.includes(window.location.pathname);
        },
    },
    computed: {
        customPlaceholder() {
            return translate('Select language');
        },
        customSelectLabel() {
            return '';
        },
        customDeselectLabel() {
            return '';
        },
        customMaxElementsText() {
            return translate(
                'Maximum number of languages selected. Please remove a language before selecting another.'
            );
        },
        customSelectedLabel() {
            return translate('Selected');
        },
    },
};
</script>
